import { z } from "zod";

export const connectDevicesToProviderRequestPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      registrationNumber: z.string(),
      deviceId: z.string(),
      vin: z.string().optional(),
      brand: z.string().optional(),
      companyUuid: z.uuid().optional(),
      departmentUuid: z.uuid().nullable().optional(),
    }),
  ),
});

export type ConnectDevicesToProviderRequestPayload = z.infer<
  typeof connectDevicesToProviderRequestPayloadSchema
>;
